@use '../colors' as colors;
@use '../vars.scss' as vars;

.document-view-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  table {
    table-layout: fixed;
    word-wrap: break-word;
    word-break: break-word;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0 8px;
    margin-bottom: 20px;

    thead {
      border-bottom: 1px solid colors.$light-grey;
    }

    th:global(.left) {
      text-align: left;
    }

    td {
      vertical-align: top;
      padding: 8px;

      p {
        margin-top: 0;
      }
    }

    img {
      width: 100%;
    }
  }

  // Overwriting bootstrap styles for the document
  :global(.btn-primary) {
    background-color: colors.$teal !important;
    border: none !important;

    &:hover {
      background-color: colors.$teal !important;
      text-decoration: none;
    }
  }
}

.wrapper {
  width: 100%;
  padding: 0 3em 3em 3em;
  height: calc(
    100vh - 56px - 89px - 48px - 32px
  ); // Calculate document height by subtracting the header, button, footer, and margin bottom heights respectively
  margin-bottom: 32px;

  @media screen and (max-width: vars.$mobile) {
    padding: 0 1em 1em 1em;
  }
}

.document {
  margin: 3em auto 0 auto;
  padding: 1em 3em 3em 3em;
  height: 100%;
  overflow: scroll;

  & > div {
    width: 100%;
  }

  @media screen and (max-width: vars.$mobile) {
    margin-top: 1em;
    padding: 1em;
  }
}

.close-footer {
  width: 100%;
  padding: 0 1em;
}

.button-close {
  margin: 0 auto;
  padding: 10px 16px;
  font-size: 18px;
}

// Flexpay
:global(.flexpay) {
  .button-close {
    padding: 18px 0;
  }

  .document-view-wrapper {
    thead {
      border-bottom: 1px solid colors.$flexpay-border;
    }

    // Overwriting bootstrap styles for the document
    :global(.btn-primary) {
      background-color: colors.$flexpay-green !important;

      &:hover {
        background-color: colors.$flexpay-green !important;
      }
    }
  }
}
